import React, { createContext, useContext, useState } from 'react';
import { useValueRef } from '../../../../hooks/useValueRef';

const Context = createContext();

export const useEvents = () => useContext(Context);

const defaultGetExtension = (attachment) => attachment.extension;

export const EventsProvider = ({
  getAttachment,
  getExtension = defaultGetExtension,
  children,
}) => {
  const eventsRef = useValueRef({
    getAttachment,
    getExtension,
  });

  const events = useState(() => eventsRef.current)[0];

  return <Context.Provider value={events}>{children}</Context.Provider>;
};
